import { CARUSO_MARKETING_SITE } from "constants/external-links";
import React from "react";

const Footer = () => (
	<footer className="bg-neutral-100 mt-10 pt-6 pb-6 justify-self-end w-full">
		<div className="max-w-container-lg mx-auto flex flex-col items-center justify-center px-3 md:flex-row md:justify-between text-body-sm">
			<a
				href={CARUSO_MARKETING_SITE}
				target="_blank"
				rel="nofollow noreferrer"
				className="text-body-sm text-neutral-600"
			>
				Investor Portal by Caruso
			</a>
		</div>
	</footer>
);

export default Footer;
